import React from 'react';
import { HashRouter } from 'react-router-dom';

import { Helmet } from 'react-helmet';

// hooks
import { useTranslation } from 'react-i18next';

import InitApp from './InitApp';
import AppRoutes from '../routes';

import custom from '../custom';
import { isPetKey } from '../helpers';

export default function App() {
  const { t } = useTranslation();

  return (
    <HashRouter>
      <InitApp />
      <Helmet>
        <title>
          {custom?.defTitle ?? ''} -{' '}
          {t(isPetKey('SIGN.IN_HEAD', custom.forPet))}
        </title>
        <meta
          name="description"
          content={t(isPetKey('SIGN.IN_TEXT', custom.forPet))}
        />
      </Helmet>
      <AppRoutes />
    </HashRouter>
  );
}
